export default "__VITE_ASSET__DytDgsm5__"